import type { App } from "vue"
import { adjustColumnWidth } from "@/utils/table"
import { permission, role } from "./permission"
import { vRepeatClick } from "./repeat-click"
import { vSafeClick } from "./safe-click"
import { userParse } from "./user-parse"

/** 挂载自定义指令 */
export function loadDirectives(app: App) {
  app.directive("permission", permission)
  app.directive("role", role)
  app.directive("user-parse", userParse)
  app.directive("repeat-click", vRepeatClick)
  app.directive("safe-click", vSafeClick)
  app.directive("fitColumns", {
    created() {},
    beforeMount() {},
    mounted(el: any) {
      setTimeout(() => {
        adjustColumnWidth(el)
      }, 300)
    },
    updated(el: any) {
      el.classList.add("r-table")
      setTimeout(() => {
        adjustColumnWidth(el)
      }, 300)
    },
    beforeUnmount() {
      console.log("beforeUnmount")
    },
    unmounted() {
      console.log("unmounted")
    },
  })
}
